import { FC } from 'react';
import { CatInlineNotification } from '@blocks-react/components/InlineNotification';
import { CatButton } from '@blocks-react/components/Button';
import { CatHeading } from '@blocks-react/components/Heading';
import { CatIconWarningCircle } from '@blocks-react/components/Icons/WarningCircle';

interface BannerProps {
  adjustButton: boolean;
  adjustButtonText: string;
  noResultText: string;
  handleFilterDrawer: object;
  isMD?: boolean;
  notificationVariant: 'success' | 'warning' | 'error' | undefined;
}
export const NotificationNoResultBanner: FC<BannerProps> = ({
  adjustButton = false,
  adjustButtonText = '',
  noResultText = '',
  handleFilterDrawer = {},
  isMD = false,
  notificationVariant,
}) => {
  return (
    <CatInlineNotification
      variant={notificationVariant}
      dismissible={false}
      data-testid="no-result-confirmation-banner"
    >
      <>
        <CatIconWarningCircle slot="before" />
        <div className={isMD ? 'row' : 'column'}>
          <div className={`${adjustButton && isMD && 'col-7'}`}>
            <CatHeading variant={isMD ? 'label-sm' : 'label'}>
              {noResultText}
            </CatHeading>
          </div>
          {adjustButton && (
            <div className={isMD ? 'col-5 flex-row-reverse' : 'd-flex mt-3'}>
              <CatButton
                variant="contrast"
                size={'md'}
                {...handleFilterDrawer}
                data-testid="adjust-button"
              >
                {adjustButtonText}
              </CatButton>
            </div>
          )}
        </div>
      </>
    </CatInlineNotification>
  );
};
